addEventListener("DOMContentLoaded", _=> {
    headerCurtain.addEventListener("click", _=> {
        ID.searchIcon.checked = false
        ID["snippet-search-searchResult"].classList.add("empty");
        ID.searchInput.value = "";
    });

    searchIcon.onclick = _=> {
        document.querySelector("#search input").focus();
        let breaker = parseInt(FN.getCSSVar(document.body, "--break-lg-end"));
        if(document.body.offsetWidth <= breaker) {
            search.style.cssText = "";
            return;
        }
        let anchor = document.querySelector(".navmenu-search");
        search.style.width = "700px";
        search.style.left = (anchor.offsetLeft - 700 + 48) + "px"; // 48 = šířka ikony
        search.style.top = anchor.offsetTop + "px";
    }
});

ID.searchInput.addEventListener('input', (event) => {
    const
        search = event.target.value,
        url = event.target.getAttribute('data-search-url');
        //url = '/?do=search-searchWhisperer';

    if (search.length >= 3 && url) {
        delay(() => {
            ID["snippet-search-searchResult"].innerHTML = `<img src="/assets/img/loading.gif" alt="loading" id="searchLoading">`;
            ID["snippet-search-searchResult"].classList.remove("empty");
            naja.makeRequest('POST', url, {
                search: search,
            }, {
                history: false,
                spinner: false
            }).then(payload => {
                //showProductVariants();
            });
            //naja.uiHandler.submitForm(ID.searchForm)
        }, 300)

    }

})

naja.addEventListener('error', (xhr, r) => {
    console.error(xhr);
    console.error(r);
});

const delay = (() => {
    let timer = 0;
    return (callback, ms) => {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    }
})();
